// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/dist/cjs.js??ref--7-oneOf-1-2!../../../../postcss-loader/dist/cjs.js??ref--7-oneOf-1-3!../../../../sass-loader/dist/cjs.js??ref--7-oneOf-1-4!./VListItemGroup.sass");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("0afde7f6", content, true, {"sourceMap":false});